import { createFileRoute } from "@tanstack/react-router";

import { ServicePageLayout } from "../components/site/ServicePageLayout";
import { ClientsMarquee } from "../components/shared/ClientsMarquee";
import { RetailHero } from "../components/retailcrm/RetailHero";
import { RetailImprove } from "../components/retailcrm/RetailImprove";
import { RetailSteps } from "../components/retailcrm/RetailSteps";
import { Reviews } from "../components/shared/Reviews";
import { Team } from "../components/shared/Team";
import { Stats } from "../components/shared/Stats";
import { LeadForm } from "../components/shared/LeadForm";
import { buildMeta, serviceJsonLd, SITE_URL } from "../lib/site";

const title = "Внедрение и настройка RetailCRM под ключ | HAY.agency";
const description =
  "Внедрение и настройка RetailCRM: заказы, коммуникации, автоматизация, интеграции и CRM-маркетинг для интернет-магазинов.";

export const Route = createFileRoute("/retailcrm")({
  head: () => ({
    ...buildMeta({ title, description, path: "/retailcrm", image: `${SITE_URL}/og/services/retailcrm.webp`, imageWidth: 1200, imageHeight: 630, imageAlt: "Внедрение RetailCRM — HAY.agency", locale: "ru_RU" }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          serviceJsonLd({
            name: "Внедрение и настройка RetailCRM",
            description,
            path: "/retailcrm",
          }),
        ),
      },
    ],
  }),
  component: Page,
});

function Page() {
  return (
    <ServicePageLayout breadcrumb="RetailCRM">
      <RetailHero />
      <RetailImprove />
      <ClientsMarquee bare />
      <RetailSteps />
      <Reviews />
      <Team />
      <Stats />
      <LeadForm
        id="event"
        title={
          <>
            Давайте обсудим, как масштабировать ваш бизнес{" "}
            <span className="text-display-muted">через RetailCRM</span>
          </>
        }
        lead="Оставьте контакты — предложим сценарий внедрения RetailCRM под ваши процессы."
        submitLabel="Обсудить проект"
      />
    </ServicePageLayout>
  );
}
